// The common component used for entering availability dates.
// Props:
//    HideStartDate : will hide the trigger for start date
//    HideEndDate : will hide the trigger for end date
//    LangData : localization data
//    SaveStartDate : a function that saves the final value of the selected start date in the parent component
//    SaveEndDate : a function that saves the final value of the selected end date in the parent component
//    InitialValue : the initial number pre-selected as value (used for preselected data displaying)
//    InitialUnit :the initial value pre-selected as unit (used for preselected data displaying)

import react, { useState } from "react";
import "../../../../../Assets/Styles/AvailabilityDatepicker.scss";
import {
  displayAvailabilityDateUnitNameText,
  formatDate,
  translateText,
} from "../../../../../Helper_functions";
import Datepicker from "../../ManualJPAs/Components/DatePicker";
import SimpleTextInputNoLabel from "../TextInput/TextInputNolabel";
import Select from "../Select/Select";

const AvalilabilityDatepicker = (props) => {
  const [StartDateIsOpen, setStartDateIsOpen] = useState(false);
  const [EndDateIsOpen, setEndDateIsOpen] = useState(false);
  const [SelectedStartDate, setSelectedStartDate] = useState();
  const [SelectedEndDate, setSelectedEndDate] = useState();
  const [MaxDate, setMaxDate] = useState();
  const [MinDate, setMinDate] = useState();
  const [SelectOptions] = useState([
    {
      name: translateText("hours_per_day", props.LangData),
      id: "HOURS_PER_DAY",
    },
    {
      name: translateText("hours_per_week", props.LangData),
      id: "HOURS_PER_WEEK",
    },
    {
      name: translateText("days_per_week", props.LangData),
      id: "DAYS_PER_WEEK",
    },
    {
      name: translateText("days_per_month", props.LangData),
      id: "DAYS_PER_MONTH",
    },
  ]);
  const [CurrentSelectOption, setCurrentSelectOption] = useState(props.InitialUnit || 'HOURS_PER_DAY')
  const [MaxValueSelectOptions] = useState({
    HOURS_PER_DAY: 24,
    HOURS_PER_WEEK: 168,
    DAYS_PER_WEEK: 7,
    DAYS_PER_MONTH: 31,
  })

  const saveStartDate = (StartDate) => {
    setSelectedStartDate(formatDate(new Date(StartDate).getTime()));
    props.SaveStartDate(new Date(StartDate).toISOString()); // saves the selected date as a state in the parent to send to API when saving
    setMinDate(new Date(StartDate));
  };

  const saveEndDate = (EndDate) => {
    setSelectedEndDate(formatDate(new Date(EndDate).getTime()));
    props.SaveEndDate(new Date(EndDate).toISOString()); // saves the selected date as a state in the parent to send to API when saving
    setMaxDate(new Date(EndDate));
  };

  const openStartDate = () => {
    setEndDateIsOpen(false);
    setStartDateIsOpen(true);
  };
  const openEndDate = () => {
    setStartDateIsOpen(false);
    setEndDateIsOpen(true);
  };

  return (
    <div className="avalability-datepicker-wrapper">
      <SimpleTextInputNoLabel
        Id="value"
        PlaceHolder={props.InitialValue ? props.InitialValue : ""}
        ValidationMessage=""
        ChangeEvent={() => null}
        InitialValue={props.InitialValue ? props.InitialValue : ""}
        Type={"number"}
        MaxValue={MaxValueSelectOptions[CurrentSelectOption]}
      />
      <Select
        Initial={
          props.InitialUnit
            ? displayAvailabilityDateUnitNameText(
                props.InitialUnit,
                props.LangData
              )
            : translateText("hours_per_day", props.LangData)
        }
        Options={SelectOptions}
        IsWithId
        Id={"avalability"}
        PreSelected={true}
        PreSelectedId={props.InitialUnit ? props.InitialUnit : "HOURS_PER_DAY"}
        ChangeHandler={(option) => setCurrentSelectOption(option.id)}
        ValidationError=""
      />
      <>
        {props.HideStartDate ? null : (
          <>
            {StartDateIsOpen ? (
              <>
                <div className="date-trigger" onClick={() => openStartDate()}>
                  <i className="feather-calendar"></i>
                  {SelectedStartDate === undefined ? (
                    <p
                      className="datepicker-placeholder"
                      id="selected-start-date"
                    >
                      {translateText("start_date", props.LangData)}
                    </p>
                  ) : (
                    <p
                      className="datepicker-placeholder filled-date"
                      id="selected-start-date"
                    >
                      {SelectedStartDate}
                    </p>
                  )}
                </div>
                <div className="datepicker-holder">
                  <Datepicker
                    Close={() => setStartDateIsOpen(false)}
                    SaveSelectedDate={(StartDate) => saveStartDate(StartDate)}
                    MaxDate={MaxDate}
                  />
                </div>
              </>
            ) : (
              <div className="date-trigger" onClick={() => openStartDate()}>
                <i className="feather-calendar"></i>
                {SelectedStartDate === undefined ? (
                  <p
                    className="datepicker-placeholder"
                    id="selected-start-date"
                    onClick={() => openStartDate()}
                  >
                    {translateText("start_date", props.LangData)}
                  </p>
                ) : (
                  <p
                    className="datepicker-placeholder filled-date"
                    id="selected-start-date"
                    onClick={() => openStartDate()}
                  >
                    {SelectedStartDate}
                  </p>
                )}
                {SelectedStartDate === undefined ? null : (
                  <i
                    className="feather-x-circle"
                    onClick={() => {
                      setSelectedStartDate(undefined)
                      setMinDate(undefined)
                    }}
                  ></i>
                )}
              </div>
            )}
          </>
        )}
      </>

      <>
        {props.HideEndDate ? null : (
          <>
            {EndDateIsOpen ? (
              <>
                <div className="date-trigger" onClick={() => openEndDate()}>
                  <i className="feather-calendar"></i>
                  {SelectedEndDate === undefined ? (
                    <p className="datepicker-placeholder">
                      {translateText("end_date", props.LangData)}
                    </p>
                  ) : (
                    <p className="datepicker-placeholder filled-date">
                      {SelectedEndDate}
                    </p>
                  )}
                </div>
                <div className="datepicker-holder">
                  <Datepicker
                    Close={() => setEndDateIsOpen(false)}
                    SaveSelectedDate={(EndDate) => saveEndDate(EndDate)}
                    MinDate={MinDate}
                  />
                </div>
              </>
            ) : (
              <div className="date-trigger" onClick={() => openEndDate()}>
                <i className="feather-calendar"></i>
                {SelectedEndDate === undefined ? (
                  <p
                    className="datepicker-placeholder"
                    onClick={() => openEndDate()}
                  >
                    {translateText("end_date", props.LangData)}
                  </p>
                ) : (
                  <p
                    className="datepicker-placeholder filled-date"
                    onClick={() => openEndDate()}
                  >
                    {SelectedEndDate}
                  </p>
                )}
                {SelectedEndDate === undefined ? null : (
                  <i
                    className="feather-x-circle"
                    onClick={() => {
                      setSelectedEndDate(undefined)
                      setMaxDate(undefined)
                    }}
                  ></i>
                )}
              </div>
            )}
          </>
        )}
      </>
    </div>
  );
};

export default AvalilabilityDatepicker;
